module.exports = __webpack_public_path__ + "static/media/vod33.95589c2b.png";